/** Suffixes that used to live inside `title` (before `hasDuplicateTitleSuffix`). */
const LEGACY_LOCALIZED_COPY = /\s+(Copy|Copia)$/u;

function stripLegacyDuplicateSuffix(storedTitle) {
  const trimmed = String(storedTitle ?? '').trim();
  if (!trimmed) return '';
  const stripped = trimmed.replace(LEGACY_LOCALIZED_COPY, '').trim();
  return stripped !== trimmed ? stripped : trimmed;
}

/**
 * Base title when persisting a duplicate (suffix not translated here).
 */
export function getDuplicateBaseTitle(dashboard) {
  const fallback = 'Untitled Dashboard';
  if (!dashboard) return fallback;
  const raw = String(dashboard.title ?? '').trim() || fallback;
  if (dashboard.hasDuplicateTitleSuffix) return raw;
  return stripLegacyDuplicateSuffix(raw) || raw;
}

/**
 * Title for list, detail, modals, and toasts; duplicate suffix follows active locale.
 */
export function getDashboardDisplayTitle(dashboard, t) {
  if (!dashboard) return '';
  const fallback = t('common.dashboardTitleFallback');
  const copyWord = t('duplicateTitleSuffix', { defaultValue: 'Copy' });
  const withCopySuffix = (base) => `${base} ${copyWord}`;

  const baseTitle = dashboard.titleKey
    ? t(dashboard.titleKey, { defaultValue: dashboard.title || fallback })
    : dashboard.title || fallback;

  if (dashboard.hasDuplicateTitleSuffix) {
    return withCopySuffix(baseTitle);
  }

  if (!dashboard.titleKey && dashboard.title) {
    const stripped = stripLegacyDuplicateSuffix(dashboard.title);
    if (stripped !== String(dashboard.title).trim()) {
      return withCopySuffix(stripped);
    }
  }

  return baseTitle;
}
